export const deserializeProject = data => {
  return {
    id: data?.id,
    shipping: data?.configuration?.shippingInfoSource,
    sizes: data?.configuration?.sizeQuantitySource,
    payment: data?.configuration?.paymentSource,
    fulfillmentMethod: data?.configuration?.fulfillmentMethod,
    shippingType: data?.configuration?.shippingType,
    estimatedQty: data?.configuration?.estimatedTotalQuantity
  };
};
